import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { WaterOwner } from '@models/waters';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrmWaterOwnersService {
  private readonly http = inject(HttpClient);

  private url(waterId: number): string {
    return `${environment.apiUrl}/api/crm/waters/${waterId}/owners`;
  }

  getOwners(waterId: number): Observable<WaterOwner[]> {
    return this.http.get<WaterOwner[]>(this.url(waterId));
  }

  linkOwner(waterId: number, customerId: number): Observable<WaterOwner[]> {
    return this.http.post<WaterOwner[]>(this.url(waterId), { customerId });
  }

  unlinkOwner(waterId: number, customerId: number): Observable<WaterOwner[]> {
    return this.http.delete<WaterOwner[]>(`${this.url(waterId)}/${customerId}`);
  }

  setPrimaryOwner(waterId: number, customerId: number): Observable<WaterOwner[]> {
    return this.http.put<WaterOwner[]>(`${this.url(waterId)}/${customerId}/primary`, {});
  }
}
